module.exports = __webpack_public_path__ + "3194fedc4b2427895acdbcd47669798b.svg";